import service from '@/plugins/service'

const base = 'auth/menu'

export const getMenuList = (current, pageSize) => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      current,
      pageSize
    }
  })
}

export const getMenu = id => {
  return service({
    url: `${base}`,
    method: 'GET',
    params: {
      id
    }
  })
}

export const getAllMenuList = () => {
  return service({
    url: `${base}/listAll`,
    method: 'GET'
  })
}

export const searchMenuList = (current, pageSize, data) => {
  return service({
    url: `${base}/query`,
    method: 'POST',
    params: {
      current,
      pageSize
    },
    data
  })
}

export const addMenu = data => {
  return service({
    url: `${base}`,
    method: 'POST',
    data
  })
}

export const removeMenu = id => {
  return service({
    url: `${base}`,
    method: 'DELETE',
    params: {
      id
    }
  })
}

export const updateMenu = data => {
  return service({
    url: `${base}`,
    method: 'PUT',
    data
  })
}

export const getMenusOfCurrentUser = () => {
  return service({
    url: `${base}/currentUser`,
    method: 'GET'
  })
}

export const getAuthoritiesList = () => {
  return service({
    url: `auth/authority/list`
  })
}